import { render, staticRenderFns } from "./no-post.vue?vue&type=template&id=55b7314c&lang=pug&"
import script from "./no-post.vue?vue&type=script&lang=js&"
export * from "./no-post.vue?vue&type=script&lang=js&"
import style0 from "./no-post.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b7314c')) {
      api.createRecord('55b7314c', component.options)
    } else {
      api.reload('55b7314c', component.options)
    }
    module.hot.accept("./no-post.vue?vue&type=template&id=55b7314c&lang=pug&", function () {
      api.rerender('55b7314c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/no-post.vue"
export default component.exports